import { TextInput, Flex, Text } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';

interface RangeInputProps {
  form: UseFormReturnType<any>;
  fromName: string;
  toName: string;
  label: string;
  placeholderFrom?: string;
  placeholderTo?: string;
}

export function RangeInput({
  form,
  fromName,
  toName,
  label,
  placeholderFrom = 'от',
  placeholderTo = 'до',
}: RangeInputProps) {
  return (
    <Flex direction='column'>
      <Text size='md' fw={600} mb={6}>
        {label}
      </Text>
      <Flex gap={8} align='center'>
        <TextInput
          placeholder={placeholderFrom}
          {...form.getInputProps(fromName)}
          type='number'
          min={0}
          variant='filled'
          w={110}
        />
        <Text size='sm' c='dimmed'>
          -
        </Text>
        <TextInput
          placeholder={placeholderTo}
          {...form.getInputProps(toName)}
          type='number'
          min={0}
          variant='filled'
          w={110}
        />
      </Flex>
    </Flex>
  );
}
